import request from '@/utils/request'

// 运营02_21 - 查看品牌报告详情
export function getCompanyBrandInfo(data) {
    return request({
        url: `/survey/companyBrand/getCompanyBrandInfo`,
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/brandInquiry.js